import { PaginatedResult } from '@nx-smartmonkey/shared/interfaces';
import { Vehicle } from '../../domain/vehicle/Vehicle';
import { VehicleActionType, VehicleActions } from './actions';
import { VehiclesTableColumn, getVehiclesTableColumns, setVehiclesTableColumns } from './tableColumns';

export interface VehicleState {
  vehicles: PaginatedResult<Vehicle>;
  vehiclesAvatarMap: Record<string, string | undefined>;
  tableColumns: Array<VehiclesTableColumn>;
}

export const getInitialState = (): VehicleState => ({
  vehicles: {
    limit: 20,
    offset: 0,
    total: 0,
    docs: [],
  },
  vehiclesAvatarMap: {},
  tableColumns: getVehiclesTableColumns(),
});

export const VehicleReducer = (state: VehicleState, action: VehicleActions): VehicleState => {
  switch (action.type) {
    case VehicleActionType.SET_VEHICLES_TABLE_COLUMNS:
      setVehiclesTableColumns(action.payload);
      return {
        ...state,
        tableColumns: action.payload,
      };
    case VehicleActionType.SEARCH_VEHICLES_SUCCESS:
      return {
        ...state,
        vehicles: action.payload.vehicles,
      };
    case VehicleActionType.GET_VEHICLE_AVATAR: {
      return {
        ...state,
        vehiclesAvatarMap: {
          ...state.vehiclesAvatarMap,
          [action.payload.vehicleId]: action.payload.vehicleAvatar,
        },
      };
    }
    default:
      return state;
  }
};
